"use strict";

import angular from "angular";

angular.module("nucont.accounting.company.monitoringConfig", ["nucont.shared"]);
require("./monitoring-config.routes");
